var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import React from 'react'
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components'
import { ODIcon, ODIcons } from '../../../../../icons'
var Wrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  visibility: ',
        ';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  //transform: translate(-50%, 0);\n  border: dashed 1px #29b6ca;\n  background-color: rgba(255, 255, 255, 0.85);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n',
      ],
      [
        '\n  visibility: ',
        ';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  //transform: translate(-50%, 0);\n  border: dashed 1px #29b6ca;\n  background-color: rgba(255, 255, 255, 0.85);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n',
      ]
    )),
  function (p) {
    return p.isOpen ? 'visible' : 'hidden'
  }
)
export var DragAndDropComponent = function (props) {
  var isOpen = props.isOpen,
    onChange = props.onChange,
    onChangeFiles = props.onChangeFiles,
    onDragLeave = props.onDragLeave,
    toggle = props.toggle,
    onClose = props.onClose,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    accept = props.accept,
    _b = props.multiple,
    multiple = _b === void 0 ? false : _b
  var _c = useDropzone({
      multiple: multiple,
      accept: accept,
      onDragLeave: function () {
        var _a
        ;(_a = onDragLeave) === null || _a === void 0 ? void 0 : _a()
      },
      onDrop: function (v) {
        var _a
        if (v.length === 0) {
          onClose()
          return
        }
        if (multiple) {
          var urls = v.map(URL.createObjectURL.bind(URL))
          ;(_a = onChangeFiles) === null || _a === void 0 ? void 0 : _a(v, urls)
          toggle()
        } else {
          v.forEach(function (file) {
            var _a
            ;(_a = onChange) === null || _a === void 0 ? void 0 : _a(file, URL.createObjectURL(file))
          })
          toggle()
        }
      },
    }),
    getRootProps = _c.getRootProps,
    getInputProps = _c.getInputProps
  // 특정 시점 이후 props 관련하여 ts 오류가 발생한다. 회피를 위해 타입을 강제로 any 로 변환하였다.
  return React.createElement(
    Wrapper,
    __assign({ isOpen: isOpen, style: style }, getRootProps()),
    React.createElement('input', __assign({ accept: accept }, getInputProps())),
    React.createElement(ODIcon, {
      icon: ODIcons.CoreImagePlus,
      style: { fontSize: 50, color: '#28b5c9', marginBottom: 25 },
    })
  )
}
var templateObject_1
//# sourceMappingURL=DragAndDropComponent.js.map
